
<div class="general-message-container" (click)="onOverlayClick($event)">
  <div class="inner">
    <div class="close-btn-container">

      <div class="close-btn-mobile" (click)="onClosePopup()">
        <img alt="Close" src="/assets/icons/close-icon.svg">
      </div>

    </div>

      <div class="message-content">
        <div class="title">
          <span [replaceKeys]="true" [fiTranslation]="title" [hasHTMLTags]="true"></span>
        </div>
          <br>
        <div class="description">
          <span [replaceKeys]="true" [fiTranslation]="content" [hasHTMLTags]="true"></span>
        </div>
      </div>
  </div>

</div>
